<script>
import {Link} from "@inertiajs/vue3";

export default {
	components: {Link},
	props: {
		customerId: {
			default: null
		}
	},
	computed: {
		available() {
			return !!this.customerId;
		}
	}
}
</script>

<template>
	<div class="d-flex flex-wrap gap-2 mb-4" v-if="$page.component !== 'customers/create' && $page.component !== 'customer_products/create'">
		<div>
			<Link
				class="btn"
				:href="route('customers.edit', {'customer': customerId})"
				:class="{
        			'btn-primary': $page.component === 'customers/edit',
        			'btn-secondary': $page.component !== 'customers/edit',
        			'disabled': !available
      			}"
			>
				Algemeen
			</Link>
		</div>

		<div>
			<Link
				class="btn" :href="route('customers.products.index', {'customer': customerId})"
				:class="{
        			'btn-primary': $page.component === 'customer_products/index',
        			'btn-secondary': $page.component !== 'customer_products/index',
        			'disabled': !available
      			}"
			>
				Beheer Producten
			</Link>
		</div>

    <div>
      <Link
          class="btn" :href="route('customers.parts.index', {customer: customerId})"
          :class="{
        			'btn-primary': $page.component === 'customers/parts',
        			'btn-secondary': $page.component !== 'customers/parts',
        			'disabled': !available
      			}"
      >
        Geleverde onderdelen
      </Link>
    </div>
	</div>
</template>